import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "logos" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoComponent = _resolveComponent("LogoComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logos, (logo, index) => {
      return (_openBlock(), _createBlock(_component_LogoComponent, {
        key: logo,
        logo: logo,
        alt: index === 0 ? 'Financial Institution Logo' : ''
      }, null, 8, ["logo", "alt"]))
    }), 128))
  ]))
}